import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { SoleBusinessMessagesEnum, SoleContact, SoleContactForm, SoleContactService } from 'taxtank-core';
import { BaseFormComponent } from '@shared/component/base/base-form.component';

@Component({
  selector: 'app-sole-contact-form',
  templateUrl: './sole-contact-form.component.html',
  styleUrls: ['./sole-contact-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SoleContactFormComponent extends BaseFormComponent {
  @Input() contact: SoleContact;
  @Output() saved: EventEmitter<SoleContact> = new EventEmitter();
  form: SoleContactForm;

  private soleContactService = inject(SoleContactService);

  buildForm(): void {
    this.form = new SoleContactForm(this.contact);
  }

  save(contact: SoleContact): void {
    if (contact.id) {
      this.soleContactService.put(contact).subscribe(() => {
        this.saved.emit(contact);
        this.toastService.success(SoleBusinessMessagesEnum.UPDATED);
      });
    } else {
      this.soleContactService.post(contact).subscribe(() => {
        this.saved.emit(contact);
        this.toastService.success(SoleBusinessMessagesEnum.CREATED);
      });
    }
  }
}
